module.exports = __webpack_public_path__ + "assets/fonts/f2b0950f3ddbe79b707b5a6e27557099.woff2";